import React, { useEffect, useMemo, useState } from "react";

import {

  ArrowLeft,

  Plus,

  Search,

  X,

} from "lucide-react";



import I from "../component/Icon";

import apiService from "../services/apiService";



const ADD_MENU_API =

  "Menu/addMenu";



const GET_PAGINATED_MENUS_API =

  "Menu/getPaginatedMenus";



const GET_ALL_MENUS_API =

  "Menu/getAllMenus?includeInActive=true";



const UPDATE_MENU_API =

  "Menu/updateMenu";



const DELETE_MENU_API =

  "Menu/DeleteMenu";



const INITIAL_MENUS = [];



const EMPTY = {

  label: "",

  icon: "",

  link: "",

  parentId: "",

  childId: "",

  title: true,

  access: true,

};



const PAGE_SIZE = 10;



export default function MenuListPage() {

  const [menus, setMenus] = useState(INITIAL_MENUS);

  const [childMenus, setChildMenus] = useState([]);

  const [search, setSearch] = useState("");



  const [pageNumber, setPageNumber] = useState(1);

  const [totalRecords, setTotalRecords] = useState(0);

  const [menusLoading, setMenusLoading] = useState(false);



  const [modalOpen, setModalOpen] = useState(false);

  const [editing, setEditing] = useState(null);



  const [form, setForm] = useState({ ...EMPTY });



  const [selectedView, setSelectedView] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);



  /* ================= NOTIFICATION ================= */



  const [notification, setNotification] = useState(null);



  const showNotification = (type, message) => {

    setNotification({

      type,

      message,

    });

  };



  useEffect(() => {

    if (!notification) return;



    const timer = setTimeout(() => {

      setNotification(null);

    }, 3000);



    return () => clearTimeout(timer);

  }, [notification]);



  const rows = useMemo(

    () => menus,

    [menus]

  );





  /* ================= GET PAGINATED MENUS ================= */



  const loadMenus = async (

    currentPage = 1,

    searchValue = "",

    signal = undefined

  ) => {

    try {

      setMenusLoading(true);



      const requestBody = {

        Page: 1,

        PageSize: 1000,

        SearchTerm: searchValue.trim(),

        SortDirection: "DESC",

        SortField: "Id",

      };



      console.log(

        "Get Paginated Menus Request:",

        requestBody

      );



      if (signal?.aborted) {

        return;

      }



      const response =

        await apiService.post(

          GET_PAGINATED_MENUS_API,

          requestBody

        );



      if (signal?.aborted) {

        return;

      }



      const result =

        response.data;



      console.log(

        "Get Paginated Menus Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const menuResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

          ? output.result

          : Array.isArray(output?.Result)

          ? output.Result

          : Array.isArray(output?.data)

          ? output.data

          : Array.isArray(output?.Data)

          ? output.Data

          : [];



      const rowCountValue =

        output?.rowCount ??

        output?.RowCount ??

        output?.totalRecords ??

        output?.TotalRecords ??

        menuResult.length;



      const normalizedMenus =

        menuResult.map((menu) => {

          const titleValue =

            menu?.isTitle ??

            menu?.IsTitle ??

            menu?.title ??

            menu?.Title ??

            false;



          const accessValue =

            menu?.isAccess ??

            menu?.IsAccess ??

            menu?.access ??

            menu?.Access ??

            false;



          const activeValue =

            menu?.isActive ??

            menu?.IsActive ??

            menu?.active ??

            menu?.Active ??

            false;



          const backendId =

            menu?.id ??

            menu?.Id ??

            menu?.menuId ??

            menu?.MenuId;



          return {

            ...menu,



            backendId,



            label:

              menu?.label ??

              menu?.Label ??

              "",



            icon:

              menu?.icon ??

              menu?.Icon ??

              "",



            link:

              menu?.link ??

              menu?.Link ??

              "",



            parentId:

              menu?.parentId ??

              menu?.ParentId ??

              0,



            childId:

              menu?.childId ??

              menu?.ChildId ??

              0,



            title:

              titleValue === true ||

              Number(titleValue) === 1 ||

              String(titleValue)

                .toLowerCase() === "true",



            access:

              accessValue === true ||

              Number(accessValue) === 1 ||

              String(accessValue)

                .toLowerCase() === "true",



            active:

              activeValue === true ||

              Number(activeValue) === 1 ||

              String(activeValue)

                .toLowerCase() === "true",

          };

        });



      /* Deleted / inactive menus table मध्ये दाखवू नका */

      const visibleMenus =

        normalizedMenus.filter(

          (menu) => menu.active

        );



      /* Active menus वर frontend pagination */

      const startIndex =

        (currentPage - 1) * PAGE_SIZE;



      const endIndex =

        startIndex + PAGE_SIZE;



      const currentPageMenus =

        visibleMenus.slice(

          startIndex,

          endIndex

        );



      /* Backend Id UI मध्ये न दाखवता frontend serial Id दाखवा */

      const menusWithDisplayId =

        currentPageMenus.map(

          (menu, index) => ({

            ...menu,



            id:

              (currentPage - 1) *

                PAGE_SIZE +

              index +

              1,



            displayId:

              (currentPage - 1) *

                PAGE_SIZE +

              index +

              1,

          })

        );



      setMenus(menusWithDisplayId);



      /* Deleted / inactive records count मध्ये घेऊ नका */

      setTotalRecords(

        visibleMenus.length

      );



    } catch (error) {

      if (

        error?.name ===

        "AbortError"

      ) {

        return;

      }



      console.error(

        "Get Paginated Menus API Error:",

        error

      );



      setMenus([]);

      setTotalRecords(0);



    } finally {

      if (!signal?.aborted) {

        setMenusLoading(false);

      }

    }

  };





  /* ================= GET ALL MENUS FOR CHILD MENU ================= */



  const loadChildMenus = async () => {

    try {

      const response =

        await apiService.get(

          GET_ALL_MENUS_API

        );



      const result =

        response.data;



      console.log(

        "Get All Menus Response:",

        result

      );



      const output =

        result?.output ??

        result?.Output ??

        result?.data ??

        result?.Data ??

        result;



      const menuResult =

        Array.isArray(output)

          ? output

          : Array.isArray(output?.result)

          ? output.result

          : Array.isArray(output?.Result)

          ? output.Result

          : Array.isArray(output?.data)

          ? output.data

          : Array.isArray(output?.Data)

          ? output.Data

          : [];



      const normalizedChildMenus =

        menuResult

          .map((menu) => ({

            backendId:

              menu?.id ??

              menu?.Id ??

              menu?.menuId ??

              menu?.MenuId,



            label:

              menu?.label ??

              menu?.Label ??

              "",

          }))

          .filter(

            (menu) =>

              menu.backendId &&

              menu.label

          );



      setChildMenus(

        normalizedChildMenus

      );



    } catch (error) {

      console.error(

        "Get All Menus API Error:",

        error

      );



      setChildMenus([]);

    }

  };





  /* ================= PAGINATION ================= */



  const totalPages = Math.max(

    1,

    Math.ceil(totalRecords / PAGE_SIZE)

  );



  const pageNumbers = Array.from(

    { length: totalPages },

    (_, index) => index + 1

  );



  const paginatedRows = useMemo(

    () => rows,

    [rows]

  );



  useEffect(() => {

    setPageNumber(1);

  }, [search]);



  useEffect(() => {

    if (pageNumber > totalPages) {

      setPageNumber(totalPages);

    }

  }, [pageNumber, totalPages]);





  /* ================= LOAD CHILD MENUS ================= */



  useEffect(() => {

    loadChildMenus();

  }, []);





  /* ================= LOAD MENUS ================= */



  useEffect(() => {

    const controller =

      new AbortController();



    const timer =

      setTimeout(() => {

        loadMenus(

          pageNumber,

          search,

          controller.signal

        );

      }, 300);



    return () => {

      clearTimeout(timer);

      controller.abort();

    };



  }, [

    pageNumber,

    search,

  ]);





  /* ================= OPEN ADD ================= */



  const openAdd = () => {

    setEditing(null);

    setForm({ ...EMPTY });

    setNotification(null);

    setModalOpen(true);

  };





  /* ================= OPEN EDIT ================= */



  const openEdit = (row) => {

    setEditing(row);

    setForm({ ...row });

    setNotification(null);

    setModalOpen(true);

  };





  /* ================= SET FIELD ================= */



  const setField = (name, value) => {

    setForm((prev) => ({

      ...prev,

      [name]: value,

    }));

  };





  /* ================= ADD / UPDATE MENU ================= */



  const save = async (event) => {

    event.preventDefault();



    if (!form.label) {

      showNotification(

        "error",

        "Menu Label is required."

      );

      return;

    }



    const payload = {

      ...form,

      parentId: Number(form.parentId || 0),

    };





    /* ================= UPDATE MENU ================= */



    if (editing) {

      try {

        const menuId = Number(

          editing?.backendId ??

          editing?.BackendId ??

          editing?.menuId ??

          editing?.MenuId

        );



        if (!menuId || Number.isNaN(menuId)) {

          showNotification(

            "error",

            "Invalid Menu Id."

          );

          return;

        }



        const childIdValue =

          Number(form.childId);



        const apiPayload = {

          Id: menuId,



          Label:

            form.label.trim(),



          Icon:

            form.icon.trim(),



          Link:

            form.link.trim(),



          ParentId:

            Number(

              form.parentId || 0

            ),



          ChildId:

            Number.isNaN(childIdValue)

              ? 0

              : childIdValue,



          IsTitle:

            Boolean(form.title),



          IsAccess:

            Boolean(form.access),



          IsActive:

            form?.active === undefined

              ? true

              : Boolean(form.active),



          subItems: [],

        };



        console.log(

          "Update Menu Request:",

          apiPayload

        );



        const response =

          await apiService.put(

            UPDATE_MENU_API,

            apiPayload

          );



        console.log(

          "Update Menu Status:",

          response.status

        );



        console.log(

          "Update Menu Response:",

          response.data

        );



        setModalOpen(false);

        setEditing(null);



        await loadMenus(

          pageNumber,

          search

        );



        await loadChildMenus();



        window.dispatchEvent(

          new Event("menusUpdated")

        );



        showNotification(

          "success",

          "Menu updated successfully."

        );



      } catch (error) {

        console.error(

          "Update Menu API Error:",

          error

        );



        showNotification(

          "error",

          error?.response?.data?.failureReason ||

          error?.response?.data?.FailureReason ||

          error?.response?.data?.message ||

          error?.response?.data?.Message ||

          error?.message ||

          "Failed to update menu"

        );

      }



      return;

    }





    /* ================= ADD MENU - BACKEND API ================= */



    try {

      const childIdValue =

        Number(form.childId);



      const apiPayload = {

        Label:

          form.label.trim(),



        Icon:

          form.icon.trim(),



        Link:

          form.link.trim(),



        ParentId:

          Number(

            form.parentId || 0

          ),



        ChildId:

          Number.isNaN(childIdValue)

            ? 0

            : childIdValue,



        IsTitle:

          Boolean(form.title),



        IsAccess:

          Boolean(form.access),



        subItems: "",



        IsActive: true,

      };



      console.log(

        "Add Menu Request:",

        apiPayload

      );



      const response =

        await apiService.post(

          ADD_MENU_API,

          apiPayload

        );



      console.log(

        "Add Menu Status:",

        response.status

      );



      console.log(

        "Add Menu Response:",

        response.data

      );



      setSearch("");

      setPageNumber(1);

      setModalOpen(false);

      setEditing(null);



      await loadMenus(

        1,

        ""

      );



      await loadChildMenus();



      window.dispatchEvent(

        new Event("menusUpdated")

      );



      showNotification(

        "success",

        "Menu added successfully."

      );



    } catch (error) {

      console.error(

        "Add Menu API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to add menu"

      );

    }

  };





  /* ================= DELETE MENU ================= */



  const confirmDelete = async () => {

    if (!deleteTarget) return;



    const menuId = Number(

      deleteTarget?.backendId ??

      deleteTarget?.BackendId ??

      deleteTarget?.menuId ??

      deleteTarget?.MenuId

    );



    if (!menuId || Number.isNaN(menuId)) {

      showNotification(

        "error",

        "Invalid Menu Id."

      );

      return;

    }



    try {

      console.log(

        "Delete Menu Id:",

        menuId

      );



      const response =

        await apiService.delete(

          `${DELETE_MENU_API}/${menuId}`

        );



      console.log(

        "Delete Menu Status:",

        response.status

      );



      console.log(

        "Delete Menu Response:",

        response.data

      );



      /* DELETE SUCCESS - REMOVE ROW FROM TABLE IMMEDIATELY */



      setMenus((prev) =>

        prev

          .filter(

            (menu) =>

              Number(

                menu?.backendId ??

                menu?.BackendId ??

                menu?.menuId ??

                menu?.MenuId

              ) !== menuId

          )

          .map(

            (menu, index) => ({

              ...menu,



              id:

                (pageNumber - 1) *

                  PAGE_SIZE +

                index +

                1,



              displayId:

                (pageNumber - 1) *

                  PAGE_SIZE +

                index +

                1,

            })

          )

      );



      setTotalRecords((prev) =>

        Math.max(

          0,

          Number(prev) - 1

        )

      );



      const moveToPreviousPage =

        pageNumber > 1 &&

        menus.length === 1;



      setDeleteTarget(null);



      if (moveToPreviousPage) {

        setPageNumber(

          (prev) =>

            Math.max(1, prev - 1)

        );

      }



      await loadChildMenus();



      window.dispatchEvent(

        new Event("menusUpdated")

      );



      showNotification(

        "success",

        "Menu deleted successfully."

      );



    } catch (error) {

      console.error(

        "Delete Menu API Error:",

        error

      );



      showNotification(

        "error",

        error?.response?.data?.failureReason ||

        error?.response?.data?.FailureReason ||

        error?.response?.data?.message ||

        error?.response?.data?.Message ||

        error?.message ||

        "Failed to delete menu"

      );

    }

  };





  /* ================= VIEW PAGE ================= */



  if (selectedView) {

    return (

      <div className="um-page">



        <div className="um-card">



          <div className="um-card-head">



            <h2>View Menu</h2>



            <button

              className="um-primary-btn"

              onClick={() => setSelectedView(null)}

            >

              <ArrowLeft size={17} />

              Back

            </button>



          </div>



          <div className="um-modal-body">



            <div className="um-grid-3">



              <label className="um-field">

                <span>Id</span>



                <input

                  value={selectedView.id}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Menu Label</span>



                <input

                  value={selectedView.label}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Menu Icon</span>



                <input

                  value={selectedView.icon}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Menu Link</span>



                <input

                  value={selectedView.link}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Parent Id</span>



                <input

                  value={selectedView.parentId}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Child Menu</span>



                <input

                  value={selectedView.childId}

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Is Title</span>



                <input

                  value={

                    selectedView.title

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />

              </label>



              <label className="um-field">

                <span>Is Access</span>



                <input

                  value={

                    selectedView.access

                      ? "Yes"

                      : "No"

                  }

                  readOnly

                />

              </label>



            </div>



          </div>



        </div>



      </div>

    );

  }





  /* ================= MAIN PAGE ================= */



  return (

    <div className="um-page">





      {/* ================= NOTIFICATION ================= */}



      {notification && (

        <div

          style={{

            position: "fixed",

            top: "20px",

            right: "20px",

            zIndex: 99999,



            minWidth: "280px",

            maxWidth: "420px",



            padding: "12px 16px",

            borderRadius: "8px",



            backgroundColor:

              notification.type === "success"

                ? "#d1e7dd"

                : "#f8d7da",



            color:

              notification.type === "success"

                ? "#0f5132"

                : "#842029",



            border:

              notification.type === "success"

                ? "1px solid #badbcc"

                : "1px solid #f5c2c7",



            fontSize: "14px",

            fontWeight: 600,



            boxShadow:

              "0 4px 12px rgba(0,0,0,0.15)",

          }}

        >

          {notification.type === "success"

            ? "✓ "

            : "✕ "}



          {notification.message}

        </div>

      )}





              <style>{`
          .um-page .um-card { min-width:0; max-width:100%; }
          .um-page .menu-pagination-footer { display:flex; align-items:center; justify-content:space-between; gap:16px; width:100%; min-width:0; max-width:100%; margin-top:16px; padding:12px 4px 4px; border-top:1px solid #eef2f7; overflow:hidden; }
          .um-page .menu-pagination-count { flex:0 0 auto; display:flex; align-items:center; color:var(--t3); font-size:11px; line-height:16px; white-space:nowrap; }
          .um-page .menu-pagination-count strong { margin:0 4px; font-weight:600; color:var(--t2); }
          .um-page .menu-pagination-bar { display:flex; align-items:center; justify-content:flex-end; gap:5px; min-width:0; max-width:100%; flex:1 1 0; overflow:hidden; }
          .um-page .menu-pagination-nav { height:32px; min-width:66px; padding:0 10px; display:inline-flex; align-items:center; justify-content:center; gap:3px; border:1px solid #e2e8f0; border-radius:6px; background:#fff; color:#475569; font-size:11px; font-weight:500; cursor:pointer; flex:0 0 auto; white-space:nowrap; }
          .um-page .menu-pagination-nav:disabled { background:#f8fafc; color:#cbd5e1; cursor:not-allowed; }
          .um-page .menu-pagination-numbers { display:flex; align-items:center; gap:4px; min-width:0; max-width:100%; flex:0 1 auto; overflow-x:auto; overflow-y:hidden; white-space:nowrap; scrollbar-width:thin; -webkit-overflow-scrolling:touch; overscroll-behavior-x:contain; }
          .um-page .menu-pagination-number { display:inline-flex; align-items:center; justify-content:center; height:32px; min-width:32px; padding:0 9px; flex:0 0 auto; border:1px solid #e2e8f0; border-radius:6px; background:#fff; color:#475569; font-size:11px; font-weight:600; cursor:pointer; }
          .um-page .menu-pagination-number.active { background:#2563eb; color:#fff; border-color:#2563eb; }
          .um-page .menu-pagination-number:disabled { cursor:not-allowed; }
          @media(max-width:768px) {
            .um-page .menu-pagination-footer { flex-direction:column; align-items:stretch; gap:10px; }
            .um-page .menu-pagination-bar { width:100%; flex:0 0 auto; justify-content:space-between; }
            .um-page .menu-pagination-numbers { flex:1 1 0; max-width:none; }
            .um-page .menu-pagination-nav { min-width:51px; padding:0 7px; font-size:10px; }
            .um-page .menu-pagination-number { min-width:30px; padding:0 7px; }
          }
        `}</style>
<div className="um-card">





        {/* ================= HEADER ================= */}



        <div className="um-card-head">



          <h2>Menu List</h2>



          <div className="um-head-actions">



            <button

              className="um-primary-btn"

              onClick={openAdd}

            >

              <Plus size={17} />

              Add New Menu

            </button>



            <label className="um-search">

              <Search size={17} />



              <input

                value={search}

                onChange={(e) =>

                  setSearch(

                    e.target.value

                  )

                }

                placeholder="Search..."

              />

            </label>



          </div>



        </div>





        {/* ================= TABLE ================= */}



        <div className="um-table-wrap">



          <table className="um-table">



            <thead>

              <tr>

                <th>Id</th>

                <th>Label</th>

                <th>Menu Icon</th>

                <th>Menu Link</th>

                <th>Parent Id</th>

                <th>Child Id</th>

                <th>Title</th>

                <th>Access</th>

                <th>Actions</th>

              </tr>

            </thead>



            <tbody>



              {menusLoading ? (



                <tr>



                  <td

                    colSpan="9"

                    style={{

                      textAlign: "center",

                      padding: "28px",

                      color: "var(--t3)",

                    }}

                  >

                    Loading menus...

                  </td>



                </tr>



              ) : paginatedRows.length === 0 ? (



                <tr>



                  <td

                    colSpan="9"

                    style={{

                      textAlign: "center",

                      padding: "28px",

                      color: "var(--t3)",

                    }}

                  >

                    No menus found

                  </td>



                </tr>



              ) : (



                paginatedRows.map((row) => (



                  <tr

                    key={

                      row.backendId ??

                      row.id

                    }

                  >



                    <td>

                      {row.id}

                    </td>



                    <td>

                      {row.label}

                    </td>



                    <td>

                      {row.icon}

                    </td>



                    <td>

                      {row.link}

                    </td>



                    <td>

                      {row.parentId}

                    </td>



                    <td>

                      {row.childId}

                    </td>



                    <td>

                      {row.title

                        ? "Yes"

                        : "No"}

                    </td>



                    <td>

                      {row.access

                        ? "Yes"

                        : "No"}

                    </td>





                    <td>



                      <div className="ra">





                        {/* VIEW */}



                        <button

                          type="button"

                          className="btn btn-p btn-sm"

                          title="View"

                          onClick={() =>

                            setSelectedView(row)

                          }

                        >

                          <I

                            n="eye"

                            s={11}

                            c="#fff"

                          />

                        </button>





                        {/* EDIT */}



                        <button

                          type="button"

                          className="btn btn-g btn-sm"

                          title="Edit"

                          onClick={() =>

                            openEdit(row)

                          }

                        >

                          <I

                            n="edit"

                            s={11}

                          />

                        </button>





                        {/* DELETE */}



                        <button

                          type="button"

                          className="btn btn-d btn-sm"

                          title="Delete"

                          onClick={() =>

                            setDeleteTarget(row)

                          }

                        >

                          <I

                            n="trash"

                            s={11}

                          />

                        </button>



                      </div>



                    </td>



                  </tr>



                ))



              )}



            </tbody>



          </table>



        </div>





          {/* Responsive pagination: numbers scroll, navigation stays visible */}
        {totalRecords > 0 && (
          <div className="menu-pagination-footer">
            <div className="menu-pagination-count">
              Showing <strong>{(pageNumber - 1) * PAGE_SIZE + 1}</strong>
              –<strong>{Math.min(pageNumber * PAGE_SIZE, totalRecords)}</strong>
              {" "}of <strong>{totalRecords}</strong>
            </div>
            <div className="menu-pagination-bar">
              <button
                type="button"
                className="menu-pagination-nav"
                disabled={pageNumber === 1 || menusLoading}
                onClick={() => setPageNumber((previous) => Math.max(1, previous - 1))}
              ><span style={{ fontSize: 16, lineHeight: 1 }}>‹</span> Back</button>
              <div className="menu-pagination-numbers" aria-label="Menu pages">
                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    type="button"
                    className={pageNumber === page ? "menu-pagination-number active" : "menu-pagination-number"}
                    aria-current={pageNumber === page ? "page" : undefined}
                    disabled={menusLoading}
                    onClick={() => setPageNumber(page)}
                  >{page}</button>
                ))}
              </div>
              <button
                type="button"
                className="menu-pagination-nav"
                disabled={pageNumber >= totalPages || menusLoading}
                onClick={() => setPageNumber((previous) => Math.min(totalPages, previous + 1))}
              >Next <span style={{ fontSize: 16, lineHeight: 1 }}>›</span></button>
            </div>
          </div>
        )}

      </div>





      {/* =====================================================

          ADD / EDIT

      ===================================================== */}



      {modalOpen && (



        <div

          className="um-modal-backdrop"

          onMouseDown={() =>

            setModalOpen(false)

          }

        >



          <form

            className="um-modal um-modal-menu"

            onSubmit={save}

            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >





            <div className="um-modal-head">



              <h3>

                {editing

                  ? "Edit Menu"

                  : "Add New Menu"}

              </h3>



              <button

                type="button"

                className="um-close-btn"

                onClick={() =>

                  setModalOpen(false)

                }

              >

                <X size={20} />

              </button>



            </div>





            <div className="um-modal-body">





              <div className="um-grid-3">





                {/* MENU LABEL */}



                <label className="um-field">



                  <span>

                    Menu Label

                  </span>



                  <input

                    value={form.label}



                    onChange={(e) =>

                      setField(

                        "label",

                        e.target.value

                      )

                    }



                    placeholder="Enter menu label"

                  />



                </label>





                {/* MENU ICON */}



                <label className="um-field">



                  <span>

                    Menu Icon

                  </span>



                  <input

                    value={form.icon}



                    onChange={(e) =>

                      setField(

                        "icon",

                        e.target.value

                      )

                    }



                    placeholder="Enter menu icon"

                  />



                </label>





                {/* MENU LINK */}



                <label className="um-field">



                  <span>

                    Menu Link

                  </span>



                  <input

                    value={form.link}



                    onChange={(e) =>

                      setField(

                        "link",

                        e.target.value

                      )

                    }



                    placeholder="Enter menu link"

                  />



                </label>



              </div>





              <div className="um-grid-1">





                {/* PARENT ID */}



                <label className="um-field">



                  <span>

                    Menu Parent Id

                  </span>



                  <input

                    type="number"



                    value={

                      form.parentId

                    }



                    onChange={(e) =>

                      setField(

                        "parentId",

                        e.target.value

                      )

                    }



                    placeholder="Enter Parent Id"

                  />



                </label>





                {/* CHILD MENU */}



                <label className="um-field">



                  <span>

                    Child Menu

                  </span>



                  <select

                    value={

                      form.childId

                    }



                    onChange={(e) =>

                      setField(

                        "childId",

                        e.target.value

                      )

                    }

                  >



                    <option value="">

                      Select Child Menu

                    </option>



                    {childMenus.map(

                      (menu) => (



                        <option

                          key={

                            menu.backendId

                          }



                          value={

                            menu.backendId

                          }

                        >

                          {menu.label}

                        </option>



                      )

                    )}



                  </select>



                </label>



              </div>





              {/* BOOLEAN */}



              <div className="um-boolean-row">





                <span>

                  Is Title

                </span>



                <button

                  type="button"



                  className={`um-toggle ${

                    form.title ? "on" : ""

                  }`}



                  onClick={() =>

                    setField(

                      "title",

                      !form.title

                    )

                  }

                >

                  <span />

                </button>



                <b>

                  {form.title

                    ? "True"

                    : "False"}

                </b>





                <span>

                  Is Access

                </span>



                <button

                  type="button"



                  className={`um-toggle ${

                    form.access ? "on" : ""

                  }`}



                  onClick={() =>

                    setField(

                      "access",

                      !form.access

                    )

                  }

                >

                  <span />

                </button>



                <b>

                  {form.access

                    ? "True"

                    : "False"}

                </b>





              </div>



            </div>





            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"



                onClick={() =>

                  setModalOpen(false)

                }

              >

                Cancel

              </button>



              <button

                className="um-primary-btn"

                type="submit"

              >

                {editing

                  ? "Update"

                  : "Add"}

              </button>



            </div>



          </form>



        </div>



      )}





      {/* =====================================================

          DELETE POPUP

      ===================================================== */}



      {deleteTarget && (



        <div

          className="um-modal-backdrop"



          onMouseDown={() =>

            setDeleteTarget(null)

          }

        >



          <div

            className="um-modal um-modal-role"



            onMouseDown={(e) =>

              e.stopPropagation()

            }

          >



            <div className="um-modal-head">



              <h3>

                Delete Menu

              </h3>



              <button

                type="button"



                className="um-close-btn"



                onClick={() =>

                  setDeleteTarget(null)

                }

              >

                <X size={20} />

              </button>



            </div>





            <div className="um-modal-body">



              <p>

                Are you sure you want to delete{" "}



                <strong>

                  {deleteTarget.label}

                </strong>



                ?

              </p>



            </div>





            <div className="um-modal-foot">



              <button

                type="button"

                className="um-cancel-btn"



                onClick={() =>

                  setDeleteTarget(null)

                }

              >

                Cancel

              </button>



              <button

                type="button"

                className="um-primary-btn"

                onClick={confirmDelete}

              >

                Delete

              </button>



            </div>



          </div>



        </div>



      )}



    </div>

  );

}